import { compose } from 'recompose';
import { connect } from 'react-redux';
import { model } from 'reducers/models/selectors';
import { seriesByModelId } from 'reducers/series/selectors';
import combineSelectors from 'utils/combineSelectors';
import { addProps, addIntlProps } from 'utils/recompose';
import messages from './messages';
import { injectIntl } from 'react-intl';
import leftArrowIcon from '../../Layout/icons/nav-arrow-left.svg';
import rightArrowIcon from '../../Layout/icons/nav-arrow-right.svg';

const mapStateToProps = combineSelectors({
  model,
  seriesByModelId,
});

export const modelUrl = ({ model }) =>
  `/series/${model.seriesId}/models/${model.id}`;

export const arrow = ({ right }) => (right ? rightArrowIcon : leftArrowIcon);

export default compose(
  connect(mapStateToProps),
  addProps({ modelUrl, arrow }),
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['seriesString'],
  }),
);
